import { useState } from 'react'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { Box, Button, Link, Paper, TextField, Typography } from '@mui/material'
import './credentials-form.css'
import { formatGqlUserMessage } from '@/common/errors/gql-error-utils'
import { AuthService } from './services/AuthService.ts'
import { useDiRef } from '@/common/react/di-hooks'

export function RegisterPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const authService = useDiRef<AuthService>('AuthService')
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    setError('')
    e.preventDefault()
    const op = await authService.register(username, password)
    if (op.error?.message) {
      setError(formatGqlUserMessage(op.error.message))
    } else {
      navigate('/')
    }
  }

  return (
    <Box className="credsPage">
      <Paper className="loginCard" elevation={3}>
        <Typography variant="h5" align="center" className="loginTitle">
          Register
        </Typography>

        <form onSubmit={handleSubmit} className="credsForm">
          <TextField
            label="Username"
            variant="outlined"
            size="small"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="credsInput"
            fullWidth
          />
          <TextField
            label="Password"
            variant="outlined"
            size="small"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="credsInput"
            fullWidth
          />
          <Button type="submit" variant="contained" color="primary" className="credsBtn" fullWidth>
            Register
          </Button>
          {error && <Typography className="errorLabel">{error}</Typography>}
          <Typography className="credsLink">
            <Link component={RouterLink} to="/auth">
              Already have an account?
            </Link>
          </Typography>
        </form>
      </Paper>
    </Box>
  )
}
